export default __webpack_public_path__ + "static/supercharge-illustration-24bb042390e27d566def1627d393c5fc.svg";